module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowExtraBold.e13b0ec.woff";